import React from 'react';
import { MilanGradientColors, S13LHR, S13LHRProps } from '@milanlaser/mlcomponents';
import { PaddingSize, paddingMap } from '../../utils/builderPaddingOptions';
import { processBackgroundAndGradientColorMap } from '../../../../components/builder/utils/builder.utils';
import { useFirebaseMetrics } from '../../utils/useFirebaseMetrics';

interface S13LHRArgs extends Omit<S13LHRProps, 'backgroundGradient' | 'imageDisplaySide'> {
    desktopPaddingTop: PaddingSize;
    desktopPaddingBottom: PaddingSize;
    mobilePaddingTop: PaddingSize;
    mobilePaddingBottom: PaddingSize;
    backgroundGradient: MilanGradientColors | 'None';
    imageDisplaySide: boolean;
    buttonDisabled: boolean;
    buttonLabel?: string;
    buttonVariant?: 'primary' | 'secondary' | 'cta';
    buttonUrl?: string;
}

export function S13LHRSection(s13Props: S13LHRArgs) {
    const { replaceVariables } = useFirebaseMetrics();
    const {
        desktopPaddingTop,
        desktopPaddingBottom,
        mobilePaddingTop,
        mobilePaddingBottom,
        backgroundGradient,
        imageDisplaySide = false,
        buttonDisabled,
        buttonLabel,
        buttonVariant,
        buttonUrl,
        ...restProps
    } = s13Props;

    const topPaddingClasses = `mcl-pt-${paddingMap[mobilePaddingTop]} lg:mcl-pt-${paddingMap[desktopPaddingTop]}`;
    const bottomPaddingClasses = `mcl-pb-${paddingMap[mobilePaddingBottom]} lg:mcl-pb-${paddingMap[desktopPaddingBottom]}`;
    const BgGradientColor = backgroundGradient === 'None' ? 'default' : backgroundGradient;

    const processedHeadline = replaceVariables(restProps.headline);
    const processedText1 = replaceVariables(restProps.text1);
    const processedText2 = restProps.text2 ? replaceVariables(restProps.text2) : undefined;

    const modifiedProps = {
        ...restProps,
        headline: processedHeadline,
        text1: processedText1,
        text2: processedText2,
        className: `${topPaddingClasses} ${bottomPaddingClasses} overflow-x-hidden`,
        backgroundGradient: BgGradientColor,
        imageDisplaySide: imageDisplaySide ? ('Right' as const) : ('Left' as const),
        buttonDisabled: !buttonDisabled,
        buttonProps: buttonLabel
            ? {
                  label: buttonLabel,
                  variant: buttonVariant,
                  target: '_self',
              }
            : undefined,
        buttonUrl: buttonUrl,
    };

    const backgroundColor = processBackgroundAndGradientColorMap({
        backgroundColor: s13Props.backgroundColor || 'default',
        gradientColor: s13Props.backgroundGradient || 'default',
    });

    return (
        <div className={`${backgroundColor}`}>
            <S13LHR {...modifiedProps} />
        </div>
    );
}
